/* eslint-disable */
import { useEffect, useState,useMemo,useRef,useCallback } from "react";
import { Tooltip,IconButton, Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import ChatModule from "../../Chat";
import { hasAuthority } from "../../../../utils/authorities";
import {capitalizeWords} from "../../../../utils/utils"
import Datatable from "../../../components/features/Datatable";
import { feasibilityPaymentStatus, selectApheresisLoading, selectFeasibilityPayments } from "../../../slices/apheresis";
import PaymentStatusModel from "./PaymentModel";
import BsModal from "../../../components/common/BaseModal";
import AddUpdatePayment  from "../../../components/taskNotificationTile/AddUpatePayment" 
import { EyeIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg"
import PaymentdashboardFilter from "./PaymentModel/filter";
import EditorApi from "../../../../services/editorManagementService";
import HospitalDropdownApi from "../../../../services/hospitalService"

const PaymentStatus = () => {
    const dispatch = useDispatch();
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const isLoading = useSelector(selectApheresisLoading);
    const feasibilityPayments = useSelector(selectFeasibilityPayments)
    const [addModal, setAddModel] = useState(false)
    const [viewDetails, setViewDetails] = useState({})
    const [editModal, setEditModal] = useState(false)
 const [products, setProducts] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const fetchDropdownData = useCallback(async () => {
        try {
            // Fetch Products
            const { loginId, role_slug } = LoginData || {};
            let editor_id;
            let investigator_id;
            let user_id;

            if (role_slug === "editor") {
                editor_id = loginId;
            } else if (role_slug === "investigator") {
                investigator_id = loginId;
            } else if (role_slug !== "superadmin") {
                user_id = loginId;
            }

            const res = await EditorApi.getPhaseDropDown("", investigator_id, editor_id, user_id);
            const productsList = (res?.data || [])
                .filter((item) => item.product_details)
                .map((item) => ({
                    label: item.product_details.name,
                    value: item.product_details.id,
                }));
            const uniqueProducts = Array.from(
                new Map(productsList.map((p) => [p.value, p])).values()
            ).sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" }));
            setProducts(uniqueProducts);
        } catch (error) {
            console.error("Error fetching products:", error);
        }

        try {
            // Fetch Hospitals
            const res = await HospitalDropdownApi.getHospitalDropDown();
            const hospitalData = res?.data?.data || res?.data || [];
            const hospitalOptions = hospitalData.map((list) => ({
                label: `${list.name} (${list.city_name})`,
                value: list.id,
                name: list.name,
            }));
            setHospitals(hospitalOptions);
        } catch (error) {
            console.error("Error fetching hospitals:", error);
        }
    }, [LoginData]);

    useEffect(() => {
        fetchDropdownData();
    }, [fetchDropdownData]);

    const productEnum = useMemo(() => {
        const enumMap = {};
        products.forEach((p) => {
            enumMap[p.value] = p.label;
        });
        return enumMap;
    }, [products]);

    const hospitalEnum = useMemo(() => {
        const enumMap = {};
        hospitals.forEach((h) => {
            enumMap[h.value] = h.label;
        });
        return enumMap;
    }, [hospitals]);

  const currentParamsRef = useRef({ page: 1, per_page: 10 });
    const tableData = {
 items: feasibilityPayments?.items || feasibilityPayments?.data?.items || feasibilityPayments?.data || [],
        total_count: feasibilityPayments?.total_count ?? feasibilityPayments?.data?.total_count ?? 0,
        page: feasibilityPayments?.page ?? feasibilityPayments?.data?.page ?? 1,
        per_page: feasibilityPayments?.per_page ?? feasibilityPayments?.data?.per_page ?? 10,
    };

        const filterConfig = useMemo(() => ({
        product_id: {
            label: "Product",
            enum: productEnum
        },
        phase_type: {
            label: "Type",
            enum: {
                'Trial': 'Trial',
                'PMS': 'PMS',
                'Commercial': 'Commercial',
            },
        },
        cycle: {
            label: "Cycle",
        },
        hospital_id: {
            label: "Hospital/Site",
            enum: hospitalEnum
        },
        payment_status: {
            label: "Payment Status",
            enum: {
                1: 'Complete',
                2: 'InComplete',
                3: 'Lease on behalf',
            },
        },
    }), [productEnum, hospitalEnum]);

    const emptyFilters = {
        product_id: [],
        phase_type: [],
        cycle: [],
        hospital_id: [],
        payment_status: [],
    };
    const fetchPayments = useCallback(async (params, activeFilters = {}) => {
         try {
         const mergedParams = {
                ...emptyFilters,     // always reset filter keys first
                ...activeFilters,    // then apply only what is active
                ...params,           // page/per_page/search always win
            };
              currentParamsRef.current = mergedParams;
                  await dispatch(feasibilityPaymentStatus(mergedParams));
                   } catch (error) {
                                console.error("Error fetching payment status data:", error);
        }
       }, [dispatch]);

   const handleServerSideChange = useCallback((params = {}) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
            sort_by,      
            sort_order,  
            ...filterParams
        } = params;
          fetchPayments({ page, per_page, search,sort_by, sort_order }, filterParams);
    }, [fetchPayments]);

    const handleCloseModal = useCallback(() => {
        setEditModal(false);
        const page = feasibilityPayments?.page ?? feasibilityPayments?.data?.page ?? 1;
        const per_page = feasibilityPayments?.per_page ?? feasibilityPayments?.data?.per_page ?? 10;
        const itemsOnCurrentPage = (feasibilityPayments?.items || feasibilityPayments?.data?.items || feasibilityPayments?.data || []).length;
        const targetPage = itemsOnCurrentPage === 1 && page > 1 ? page - 1 : page;
        // Re-fetch with the same filters that were active when the modal opened
        const lastParams = currentParamsRef.current;
        fetchPayments(
             { page: targetPage, per_page,sort_by: lastParams.sort_by,
            sort_order: lastParams.sort_order, },
            {
                product_id: lastParams.product_id || [],
                phase_type: lastParams.phase_type || [],
                cycle: lastParams.cycle || [],
                hospital_id: lastParams.hospital_id || [],
                payment_status: lastParams.payment_status || [],
            }
        );
    }, [feasibilityPayments, fetchPayments]);
    const columns = [
        {
            id: "subject_code",
            name: "ID",
            selector: (row) => (row.patient_id ? row.patient_id : "N/A"),
            sortable: true,
        },
        {
            id: "subject_name",
            name: "Subject/Patient Name",
            selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
            sortable: true,
        },
        {
            id: "product",
            name: "Product/Phase",
            selector: (row) =>
                row.product && row.phase ? `${capitalizeWords(row.product)}/${capitalizeWords(row.phase)}` : "N/A",
            sortable: true,
        },
        {
            id: "phase_type",
            name: "Type",
            selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
            sortable: true,
        },
          {
            id: "cycleObject",
            name: "Cycle",
            selector: (row) => (row.cycleObject ? row.cycleObject : "N/A"),
            sortable: true,
        },
        {
            id: "hospital_name",
            name: "Hospital/Site",
            selector: (row) =>
                row?.hospitals?.length > 0
                ? row.hospitals?.map((it) => it?.name).join(" | ")
                : "N/A",
            sortable: true,
            },
        {
            id: "payment_status",
            name: "Payment Status",
           selector: (row) => row.payment_status ? row.payment_status : "Pending",
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => (
                <div className="flex gap-2 relative">
                     {hasAuthority(["payment-dash-view"], bmr_permissions) &&
                     <Tooltip title="View Details"  key={'key_'+row?.subject_id}>
                                        <span  key={'key_'+row?.subject_id}>
                                            <IconButton
                        onClick={() => {  setEditModal(false), setAddModel(true), setViewDetails(row) }}
                                            >
                                                <EyeIconButton
                                                    bgColor={"#3571FF"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>}
                     {hasAuthority(["update-payment-status"], bmr_permissions) &&
                      <Tooltip title="Edit"  key={row?.subject_id}>
                                        <span  key={row?.subject_id}>
                                            <IconButton
                               onClick={() => {setAddModel(false), setEditModal(true), setViewDetails(row) }}
                                            >
                                                <EditIconButton
                                                    bgColor={"#3571FF"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>}
                     
                </div>
            ),
        },
    ];
    const FilterWrapper = useCallback((props) => (
        <PaymentdashboardFilter
            {...props}
            products={products}
            hospitals={hospitals}
        />
    ), [products, hospitals]);
    return (
        <Grid
            container
            className="mt-4 ml-0 mr-3 mainDiv"
            rowSpacing={4.5}
            columnSpacing={2.75}
        >
            <BsModal open={addModal} onClose={() => setAddModel(false)} title={"Payment Details "}>
                <PaymentStatusModel data={viewDetails} />
            </BsModal>
            <BsModal open={!!editModal} onClose={() => setEditModal(false)} title={`Update Payment Status`}>
                <AddUpdatePayment editData={viewDetails}  feasiblityId={viewDetails?.id}  productManufacturingId={viewDetails?.product_manufacturing_id} handleCloseModal={handleCloseModal}/>
            </BsModal>
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                {hasAuthority(["bmr-slots-view"], bmr_permissions) && (
                    <div>
                        <Datatable
                            columns={columns}
                            data={tableData}
                            title="Payment Dashboard"
                            onServerSideChange={handleServerSideChange}
                            remote={true}
                            loading={isLoading}
                              FilterComponent={FilterWrapper}
                            filterConfig={filterConfig}
                        />
                        <ChatModule />
                    </div>
                )}
            </Grid>
        </Grid>
    );
}

export default PaymentStatus;
